(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ACCESSIBILE"] && !Shopify.designMode) return;
  try {
    (function() {
  var hn = window.location.hostname;
  var pth = window.location.pathname;
  if (hn === 'admin.shopify.com' || (hn.endsWith('.myshopify.com') && pth.startsWith('/admin')) || (window.self !== window.top && document.referrer.includes('admin.shopify.com'))) return;

  var panel = document.getElementById('ait-panel');
  var toggle = document.getElementById('ait-toggle');
  var closeBtn = document.getElementById('ait-close-panel');
  
  // Posiziona il bottone floating vicino al pannello quando è aperto
  function positionCloseBtn() {
    if (!panel || !closeBtn) return;
    var rect = panel.getBoundingClientRect();
    if (rect.width === 0) { setTimeout(positionCloseBtn, 100); return; }
    closeBtn.style.top = Math.max(8, rect.top - 20) + 'px';
    closeBtn.style.right = Math.max(4, window.innerWidth - rect.right - 2) + 'px';
    closeBtn.style.display = 'flex';
  }
  var mask = document.getElementById('ait-reading-mask');

  if (!panel || !toggle) return;

  var isOpen = false;
  var maskActive = false;
  var ttsActive = false;
  var ttsRate = 1.0;
  var ttsVoice = null;

  function togglePanel(open) {
    if (open === undefined) open = !isOpen;
    isOpen = open;
    panel.classList.toggle('ait-open', open);
    panel.style.display = open ? 'block' : 'none';
    toggle.setAttribute('aria-expanded', String(open));
    if (open) {
      setTimeout(positionCloseBtn, 20);
      setTimeout(positionCloseBtn, 150);
      var firstFocus = panel.querySelector('button:not([disabled]), input, [tabindex]');
      if (firstFocus) setTimeout(function() { firstFocus.focus(); }, 50);
    } else {
      if (closeBtn) closeBtn.style.display = 'none';
    }
  }

  // Riposiziona il bottone al resize della finestra
  window.addEventListener('resize', function() { if (isOpen) positionCloseBtn(); });

  toggle.addEventListener('click', function() { togglePanel(); });
  toggle.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); togglePanel(); } });
  if (closeBtn) closeBtn.addEventListener('click', function() { togglePanel(false); });

  document.querySelectorAll('.ait-toggle-switch[data-profile]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.stopPropagation();
      var profile = this.getAttribute('data-profile');
      var active = this.classList.toggle('active');
      this.setAttribute('aria-checked', String(active));
      var b = document.body;
      b.classList.toggle('ait-' + profile, active);
      if (profile === 'epilessia') {
        document.querySelectorAll('video, iframe').forEach(function(v) {
          v.style.opacity = active ? '0.2' : '';
          v.style.pointerEvents = active ? 'none' : '';
        });
        b.classList.toggle('ait-stop-animations', active);
      }
      if (profile === 'ipovedenti') {
        b.classList.toggle('ait-high-contrast', active);
        b.classList.toggle('ait-big-text', active);
        b.classList.toggle('ait-big-cursor', active);
        b.classList.toggle('ait-highlight-links', active);
      }
      if (profile === 'adhd') {
        b.classList.toggle('ait-big-text', active);
        b.classList.toggle('ait-grayscale', active);
        b.classList.toggle('ait-stop-animations', active);
      }
      if (profile === 'lettura') {
        b.classList.toggle('ait-font-readable', active);
        b.classList.toggle('ait-line-spacing', active);
        b.classList.toggle('ait-letter-spacing', active);
      }
      if (profile === 'tastiera') b.classList.toggle('ait-highlight-focus', active);
      if (profile === 'screenreader') {
        // Struttura pagina: aggiunge skip-link e migliora ARIA
        if (active) {
          if (!document.getElementById('ait-skip-link')) {
            var skipLink = document.createElement('a');
            skipLink.id = 'ait-skip-link';
            var mainEl = document.querySelector('main, [role="main"], #MainContent, #main, .main-content');
            skipLink.href = mainEl ? '#' + (mainEl.id || 'ait-main-target') : '#';
            if (mainEl && !mainEl.id) mainEl.id = 'ait-main-target';
            skipLink.textContent = t ? (aitLang === 'en' ? 'Skip to main content' : 'Vai al contenuto principale') : 'Vai al contenuto principale';
            skipLink.style.cssText = 'position:fixed;top:8px;left:50%;transform:translateX(-50%);z-index:2147483646;background:#1A7A4A;color:#fff;padding:8px 16px;border-radius:4px;font-size:13px;font-weight:bold;text-decoration:none;box-shadow:0 2px 8px rgba(0,0,0,0.3);';
            document.body.insertBefore(skipLink, document.body.firstChild);
          }
          if (mainEl) mainEl.setAttribute('role', 'main');
        } else {
          var sl = document.getElementById('ait-skip-link');
          if (sl) sl.remove();
        }
      }
      if (profile === 'anziani') {
        b.classList.toggle('ait-big-text', active);
        b.classList.toggle('ait-high-contrast', active);
        b.classList.toggle('ait-line-spacing', active);
      }
      // Salva stato profilo in localStorage
      try {
        var saved = JSON.parse(localStorage.getItem('ait-state') || '{}');
        saved['profile-' + profile] = active;
        localStorage.setItem('ait-state', JSON.stringify(saved));
      } catch(e) {}
    });
    el.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
    });
  });

  document.querySelectorAll('.ait-info-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var info = document.getElementById(this.getAttribute('data-target'));
      if (!info) return;
      var wasOpen = info.style.display !== 'none';
      document.querySelectorAll('.ait-profile-info').forEach(function(el) { el.style.display = 'none'; });
      info.style.display = wasOpen ? 'none' : 'block';
    });
  });

  document.querySelectorAll('.ait-toggle-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var key = this.getAttribute('data-toggle');
      if (!key) return;
      var active = document.body.classList.toggle('ait-' + key);
      this.classList.toggle('active', active);

      if (key === 'reading-mask') {
        maskActive = active;
        if (active) {
          updateMask(window.innerHeight / 2);
          mask.style.display = 'block';
        } else {
          mask.style.display = 'none';
        }
      }
      if (key === 'mute-sounds') {
        document.querySelectorAll('audio, video').forEach(function(el) {
          el.muted = active;
        });
      }
      // Salva stato toggle in localStorage
      try {
        var saved = JSON.parse(localStorage.getItem('ait-state') || '{}');
        saved['toggle-' + key] = active;
        localStorage.setItem('ait-state', JSON.stringify(saved));
      } catch(e) {}
    });
  });

  // Ripristina stato salvato al caricamento
  (function restoreState() {
    try {
      var saved = JSON.parse(localStorage.getItem('ait-state') || '{}');
      Object.keys(saved).forEach(function(k) {
        if (!saved[k]) return;
        if (k.startsWith('profile-')) {
          var profile = k.replace('profile-', '');
          var sw = document.querySelector('.ait-toggle-switch[data-profile="' + profile + '"]');
          if (sw && !sw.classList.contains('active')) sw.click();
        } else if (k.startsWith('toggle-')) {
          var key = k.replace('toggle-', '');
          var btn = document.querySelector('.ait-toggle-btn[data-toggle="' + key + '"]');
          if (btn && !btn.classList.contains('active')) btn.click();
        }
      });
    } catch(e) {}
  })();

  var maskCurrentY = -1;

  function updateMask(clientY) {
    if (!mask) return;
    var vh = window.innerHeight;
    var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var bandH = Math.round(vh * (vw < 768 ? 0.30 : 0.36));
    var top = Math.max(0, Math.min(Math.round(clientY - bandH / 2), vh - bandH));
    maskCurrentY = clientY;

    /* Tecnica box-shadow: un solo elemento posizionato sulla banda di lettura.
       Il box-shadow enorme copre tutto il resto con rgba(0,0,0,0.55). */
    mask.style.top = top + 'px';
    mask.style.height = bandH + 'px';
    mask.style.boxShadow = '0 0 0 9999px rgba(0,0,0,0.55)';
  }

  var maskRaf = null;

  function onMaskPointer(clientY) {
    if (!maskActive) return;
    if (maskRaf) cancelAnimationFrame(maskRaf);
    maskRaf = requestAnimationFrame(function() {
      updateMask(clientY);
      maskRaf = null;
    });
  }

  document.addEventListener('mousemove', function(e) {
    onMaskPointer(e.clientY);
  });

  /* Touch: aggiorna su ogni touchmove */
  document.addEventListener('touchmove', function(e) {
    if (!maskActive) return;
    var t = e.touches[0];
    if (t) onMaskPointer(t.clientY);
  }, { passive: true });

  /* Scroll su mobile: la maschera è position:fixed quindi rimane ancorata al viewport.
     Su mobile con barre dinamiche (Chrome/Safari) aggiorniamo l'altezza della banda. */
  window.addEventListener('scroll', function() {
    if (!maskActive) return;
    if (maskRaf) cancelAnimationFrame(maskRaf);
    maskRaf = requestAnimationFrame(function() {
      updateMask(maskCurrentY >= 0 ? maskCurrentY : window.innerHeight * 0.4);
      maskRaf = null;
    });
  }, { passive: true });

  window.addEventListener('resize', function() {
    if (maskActive) updateMask(maskCurrentY >= 0 ? maskCurrentY : window.innerHeight / 2);
  });

  // ---- RGAA SCANNER ----
  var scanBtn = document.getElementById('ait-scan-rgaa-btn');
  var scanResults = document.getElementById('ait-scan-results');
  var scanList = document.getElementById('ait-scan-list');
  var scanSummary = document.getElementById('ait-scan-summary');
  var scanBadge = document.getElementById('ait-scan-badge');

  function runRGAAScan() {
    scanBtn.disabled = true;
    scanBtn.innerHTML = '⏳ Scansione in corso...';
    scanResults.classList.remove('visible');
    setTimeout(function() {
      var results = [];
      var doc = document;
      // WCAG 1.1.1 - Testo alternativo immagini
      var imgs = doc.querySelectorAll('img:not([role="presentation"]):not([alt=""])');
      var missingAlt = Array.from(imgs).filter(function(i) { return i.getAttribute('alt') === null && !i.getAttribute('aria-label'); });
      results.push({ check: 'alt', pass: missingAlt.length === 0, warn: missingAlt.length > 0 && missingAlt.length <= 2,
        msg: missingAlt.length === 0 ? '✅ Alt text: tutte le immagini hanno testo alternativo' : '⚠️ Alt text: ' + missingAlt.length + ' immagini senza alt (WCAG 1.1.1)' });
      // WCAG 1.3.1 - Struttura heading
      var h1Count = doc.querySelectorAll('h1').length;
      var h2Count = doc.querySelectorAll('h2').length;
      var headingPass = h1Count === 1 && h2Count > 0;
      var headingWarn = h1Count === 1 && h2Count === 0;
      results.push({ check: 'heading', pass: headingPass, warn: headingWarn,
        msg: h1Count === 0 ? '❌ Heading: manca h1 (WCAG 1.3.1)' : h1Count > 1 ? '⚠️ Heading: ' + h1Count + ' h1 trovati, dovrebbe essere uno solo' : headingPass ? '✅ Heading: struttura corretta (h1 + h2)' : '⚠️ Heading: h1 presente ma mancano h2' });
      // WCAG 1.4.3 - Contrasto (verifica manuale)
      results.push({ check: 'contrast', pass: false, warn: true,
        msg: '⚠️ Contrasto: verifica manuale richiesta — min. 4.5:1 testo normale, 3:1 testo grande (WCAG 1.4.3)' });
      // WCAG 2.4.4 - Link accessibili
      var iconLinks = doc.querySelectorAll('a:has(img), a:has(svg)');
      var linkIssues = 0;
      iconLinks.forEach(function(a) { if (!a.getAttribute('aria-label') && !a.getAttribute('title') && !a.textContent.trim()) linkIssues++; });
      results.push({ check: 'links', pass: linkIssues === 0, warn: false,
        msg: linkIssues === 0 ? '✅ Link: tutti i link hanno testo accessibile' : '❌ Link: ' + linkIssues + ' link senza testo accessibile (WCAG 2.4.4)' });
      // WCAG 1.3.1 - Label form
      var inputs = doc.querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="reset"]):not([type="image"])');
      var noLabel = 0;
      inputs.forEach(function(inp) {
        var id = inp.id;
        var hasLabel = (id && doc.querySelector('label[for="' + id + '"]')) || inp.getAttribute('aria-label') || inp.getAttribute('aria-labelledby') || inp.getAttribute('title');
        if (!hasLabel) noLabel++;
      });
      results.push({ check: 'labels', pass: noLabel === 0, warn: false,
        msg: noLabel === 0 ? '✅ Form: tutti i campi hanno etichetta' : '❌ Form: ' + noLabel + ' campi senza label (WCAG 1.3.1)' });
      // WCAG 3.1.1 - Lingua pagina
      var lang = doc.documentElement.getAttribute('lang');
      results.push({ check: 'lang', pass: !!(lang && lang.length >= 2), warn: false,
        msg: (lang && lang.length >= 2) ? '✅ Lingua: dichiarata (' + lang + ')' : '❌ Lingua: attributo lang mancante nel tag html (WCAG 3.1.1)' });
      // WCAG 2.4.1 - Skip link
      var skipLink = doc.querySelector('a[href^="#main"], a[href^="#content"], a[href^="#MainContent"], a.skip-link, a[class*="skip"]');
      results.push({ check: 'skip', pass: !!skipLink, warn: !skipLink,
        msg: skipLink ? '✅ Skip link: presente' : '⚠️ Skip link: consigliato un link "Vai al contenuto" (WCAG 2.4.1)' });
      var passed = results.filter(function(r) { return r.pass; }).length;
      var warned = results.filter(function(r) { return r.warn && !r.pass; }).length;
      var failed = results.filter(function(r) { return !r.pass && !r.warn; }).length;
      var total = results.length;
      var score = Math.round(((passed + warned * 0.5) / total) * 100);
      scanBadge.textContent = score >= 80 ? '✅' : score >= 50 ? '⚠️' : '❌';
      scanBadge.className = 'ait-badge' + (score < 50 ? ' danger' : score < 80 ? ' warning' : '');
      scanList.innerHTML = results.map(function(r) {
        return '<div class="ait-scan-result-item"><span>' + r.msg + '</span></div>';
      }).join('');
      scanSummary.innerHTML = '<span>✅ ' + passed + ' OK</span><span>⚠️ ' + warned + ' Avvisi</span><span>❌ ' + failed + ' Errori</span><span>📊 ' + score + '%</span>';
      var disc = document.getElementById('ait-scan-disclaimer');
      if (disc) {
        disc.textContent = (t && t.scanDisclaimer) ? t.scanDisclaimer : 'La scansione automatica intercetta circa il 20–30% dei criteri WCAG 2.1 AA (EN 301 549). La verifica completa richiede audit manuale e test con tecnologie assistive.';
        disc.style.display = 'block';
      }
      scanResults.classList.add('visible');
      scanBtn.innerHTML = (t && t.scanBtn) ? t.scanBtn : '🔍 Esegui scansione WCAG 2.1 AA';
      scanBtn.disabled = false;
    }, 300);
  }
  if (scanBtn) scanBtn.addEventListener('click', runRGAAScan);

  // ---- AI Alt Text ----
  var altBtn = document.getElementById('ait-alt-text-btn');
  var altArea = document.getElementById('ait-alt-text-area');
  var altOutput = document.getElementById('ait-alt-text-output');
  var altGenerate = document.getElementById('ait-alt-generate-btn');
  var altCopy = document.getElementById('ait-alt-copy-btn');
  var altStatus = document.getElementById('ait-alt-status');

  function generateAltText() {
    altGenerate.disabled = true;
    altStatus.textContent = '⏳ Generazione in corso...';
    var images = document.querySelectorAll('img:not([alt]), img[alt=""]');
    var imgList = [];
    images.forEach(function(img) {
      var src = img.src || '';
      if (src && !src.startsWith('data:')) imgList.push(src);
    });
    if (imgList.length === 0) {
      altStatus.textContent = '✅ Tutte le immagini hanno un alt text!';
      altGenerate.disabled = false;
      return;
    }
    var suggestions = imgList.map(function(src, i) {
      var filename = src.split('/').pop() || 'immagine_' + (i+1);
      return 'img ' + (i+1) + ': Descrizione per ' + filename.replace(/\.(png|jpg|jpeg|gif|webp|svg)$/i, '');
    });
    altOutput.value = suggestions.join('\n');
    altStatus.textContent = '✅ Generati ' + suggestions.length + ' alt text. Copia e incolla nel codice.';
    altGenerate.disabled = false;
    altArea.classList.add('visible');
  }
  if (altBtn) {
    altBtn.addEventListener('click', function() {
      altArea.classList.toggle('visible');
      if (altArea.classList.contains('visible')) generateAltText();
    });
  }
  if (altGenerate) altGenerate.addEventListener('click', generateAltText);
  if (altCopy) {
    altCopy.addEventListener('click', function() {
      if (altOutput.value) {
        navigator.clipboard.writeText(altOutput.value).then(function() {
          altStatus.textContent = '✅ Copiato negli appunti!';
          setTimeout(function() { altStatus.textContent = 'Pronto'; }, 2000);
        });
      }
    });
  }

  // ---- RESET ----
  var resetBtn = document.getElementById('ait-reset-all');
  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      var b = document.body;
      var toRemove = [];
      for (var i = 0; i < b.classList.length; i++) {
        if (b.classList[i].startsWith('ait-')) toRemove.push(b.classList[i]);
      }
      toRemove.forEach(function(c) { b.classList.remove(c); });
      document.querySelectorAll('.ait-toggle-switch.active').forEach(function(el) {
        el.classList.remove('active');
        el.setAttribute('aria-checked', 'false');
      });
      document.querySelectorAll('.ait-toggle-btn.active').forEach(function(el) {
        el.classList.remove('active');
      });
      if (maskActive) {
        maskActive = false;
        if (mask) { mask.style.display = 'none'; mask.style.boxShadow = 'none'; }
      }
      document.querySelectorAll('video, iframe').forEach(function(el) {
        el.style.opacity = '';
        el.style.pointerEvents = '';
      });
      document.querySelectorAll('audio, video').forEach(function(el) { el.muted = false; });
      var ttsStatus = document.getElementById('ait-tts-status');
      if (ttsStatus) ttsStatus.textContent = 'Leggi';
      window.speechSynthesis.cancel();
      if (scanResults) scanResults.classList.remove('visible');
      if (scanBadge) { scanBadge.textContent = '📊'; scanBadge.className = 'ait-badge'; }
      // Pulisce lo stato salvato
      try { localStorage.removeItem('ait-state'); } catch(e) {}
    });
  }

  // ---- NASCONDI WIDGET ----
  var hideBtn = document.getElementById('ait-hide-widget');
  if (hideBtn) {
    hideBtn.addEventListener('click', function() {
      panel.style.display = 'none';
    if (closeBtn) closeBtn.style.display = 'none';
      toggle.style.display = 'none';
      setTimeout(function() { toggle.style.display = 'flex'; }, 10000);
    });
  }


  // ---- MULTILINGUA ----
  // Rilevamento lingua: html[lang] → og:locale → navigator.language → default 'it'
  var aitLang = (function() {
    var l = document.documentElement.lang;
    if (!l) {
      var ogLocale = document.querySelector('meta[property="og:locale"]');
      if (ogLocale) l = ogLocale.getAttribute('content');
    }
    if (!l) l = navigator.language;
    if (!l) l = 'it';
    return l.toLowerCase().substring(0, 2);
  })();
  var aitT = {
    it: {
      read: 'Leggi', reading: 'In lettura...', slow: '🐢 Lenta', normal: '▶ Normale', fast: '🐇 Veloce',
      ttsHint: "Seleziona un testo e premi Leggi, oppure leggi l'intera pagina",
      ttsTitle: 'Leggi ad alta voce',
      reset: '🔄 Resetta tutto', declaration: '📄 Dichiarazione', hide: '🙈 Nascondi widget',
      scanBtn: '🔍 Esegui scansione WCAG 2.1 AA', scanTitle: '📋 Scanner WCAG 2.1 AA',
      scanDisclaimer: 'La scansione automatica intercetta circa il 20–30% dei criteri WCAG 2.1 AA (EN 301 549). La verifica completa richiede audit manuale e test con tecnologie assistive.',
      altBtn: '🤖 Genera Alt Text per questa pagina', altTitle: '🖼️ Alt Text con AI',
      altReady: 'Pronto', altGenerate: '🔄 Genera', altCopy: '📋 Copia',
      altPlaceholder: 'Genera alt text per le immagini della pagina...',
      secProfiles: 'Profili rapidi', secContent: 'Regolazioni contenuti',
      secColor: 'Regolazioni colore', secReading: 'Lettura e orientamento',
      profileEpilessia: '⚡ Sicurezza animazioni', profileIpovedenti: '🔍 Ingrandimento e contrasto',
      profileAdhd: '🎯 Riduci distrazioni', profileLettura: '📚 Lettura facilitata',
      profileTastiera: '⌨️ Navigazione tastiera', profileScreenreader: '📄 Struttura pagina',
      profileAnziani: '👓 Supporto visivo',
      infoEpilessia: 'Riduce animazioni, effetti lampeggianti e pattern visivi intensi. Ideale per chi è sensibile al movimento o ai contrasti rapidi.',
      infoIpovedenti: 'Aumenta la dimensione del testo e migliora il contrasto visivo per una lettura più chiara e confortevole.',
      infoAdhd: 'Riduce il disordine visivo e le distrazioni per favorire la concentrazione sui contenuti principali.',
      infoLettura: 'Semplifica la lettura e la navigazione. Aumenta la spaziatura tra lettere e righe, utilizza un font più leggibile e riduce gli elementi visivi non essenziali.',
      infoTastiera: 'Abilita la navigazione completa del sito web con la tastiera. Tutti gli elementi interattivi diventano raggiungibili e utilizzabili senza mouse.',
      infoScreenreader: 'Migliora la struttura semantica della pagina: heading ordinati, skip-link e attributi ARIA per una navigazione più chiara.',
      infoAnziani: 'Aumenta il testo, migliora il contrasto e semplifica la navigazione per un uso più agevole e confortevole.',
      btnFontReadable: '📖 Font Leggibile', btnBigText: '🔤 Testo Grande',
      btnHighlightLinks: '🔗 Evidenzia Link', btnBigCursor: '🖱️ Cursore Grande',
      btnHideImages: '🖼️ Nascondi immagini', btnHighlightTitles: '📌 Evidenzia titoli',
      btnReadingMode: '📖 Modalità lettura',
      btnHighContrast: '⬛ Alto Contrasto', btnGrayscale: '⚪ Scala di Grigi',
      btnDarkMode: '🌙 Modalità Scura', btnContrastLight: '☀️ Contrasto chiaro',
      btnContrastDark: '🌑 Contrasto scuro', btnContrastHigh: '🔆 Contrasto elevato',
      btnSatHigh: '🌈 Saturazione alta', btnSatLow: '🌫️ Saturazione bassa',
      btnMono: '🖤 Monocromatico',
      btnLineSpacing: '📏 Interlinea', btnLetterSpacing: '🔤 Spaziatura',
      btnStopAnim: '⏸️ Ferma Animazioni', btnReadingMask: '🎭 Maschera Lettura',
      btnHighlightFocus: '🎯 Evidenzia focus', btnHighlightHover: '👆 Evidenzia hover',
      btnMuteSounds: '🔇 Disattiva suoni',
      toggleOn: 'SI', toggleOff: 'NO'
    },
    en: {
      read: 'Read', reading: 'Reading...', slow: '🐢 Slow', normal: '▶ Normal', fast: '🐇 Fast',
      ttsHint: 'Select text and press Read, or read the entire page',
      ttsTitle: 'Read aloud',
      reset: '🔄 Reset all', declaration: '📄 Declaration', hide: '🙈 Hide widget',
      scanBtn: '🔍 Run WCAG 2.1 AA scan', scanTitle: '📋 WCAG 2.1 AA Scanner',
      scanDisclaimer: 'Automated scanning covers approximately 20–30% of WCAG 2.1 AA criteria (EN 301 549). Full compliance requires manual audit and testing with assistive technologies.',
      altBtn: '🤖 Generate Alt Text for this page', altTitle: '🖼️ AI Alt Text',
      altReady: 'Ready', altGenerate: '🔄 Generate', altCopy: '📋 Copy',
      altPlaceholder: 'Generate alt text for images on this page...',
      secProfiles: 'Quick Profiles', secContent: 'Content Adjustments',
      secColor: 'Color Adjustments', secReading: 'Reading & Orientation',
      profileEpilessia: '⚡ Animation Safety', profileIpovedenti: '🔍 Zoom & Contrast',
      profileAdhd: '🎯 Reduce Distractions', profileLettura: '📚 Easy Reading',
      profileTastiera: '⌨️ Keyboard Navigation', profileScreenreader: '📄 Page Structure',
      profileAnziani: '👓 Visual Support',
      infoEpilessia: 'Reduces animations, flashing effects and intense visual patterns. Ideal for users sensitive to motion or rapid contrasts.',
      infoIpovedenti: 'Increases text size and improves visual contrast for clearer, more comfortable reading.',
      infoAdhd: 'Reduces visual clutter and distractions to help you focus on the main content.',
      infoLettura: 'Simplifies reading and navigation. Increases letter and line spacing, uses a more readable font, and reduces non-essential visual elements.',
      infoTastiera: 'Enables full keyboard navigation of the website. All interactive elements become reachable and usable without a mouse.',
      infoScreenreader: 'Improves page semantic structure: ordered headings, skip-links and ARIA attributes for clearer navigation.',
      infoAnziani: 'Increases text size, improves contrast and simplifies navigation for more comfortable use.',
      btnFontReadable: '📖 Readable Font', btnBigText: '🔤 Large Text',
      btnHighlightLinks: '🔗 Highlight Links', btnBigCursor: '🖱️ Large Cursor',
      btnHideImages: '🖼️ Hide Images', btnHighlightTitles: '📌 Highlight Titles',
      btnReadingMode: '📖 Reading Mode',
      btnHighContrast: '⬛ High Contrast', btnGrayscale: '⚪ Grayscale',
      btnDarkMode: '🌙 Dark Mode', btnContrastLight: '☀️ Light Contrast',
      btnContrastDark: '🌑 Dark Contrast', btnContrastHigh: '🔆 High Contrast+',
      btnSatHigh: '🌈 High Saturation', btnSatLow: '🌫️ Low Saturation',
      btnMono: '🖤 Monochrome',
      btnLineSpacing: '📏 Line Spacing', btnLetterSpacing: '🔤 Letter Spacing',
      btnStopAnim: '⏸️ Stop Animations', btnReadingMask: '🎭 Reading Mask',
      btnHighlightFocus: '🎯 Highlight Focus', btnHighlightHover: '👆 Highlight Hover',
      btnMuteSounds: '🔇 Mute Sounds',
      toggleOn: 'YES', toggleOff: 'NO'
    }
  };
  var t = aitT[aitLang] || aitT['it'];


  // Inizializza bottoni lingua in base alla lingua rilevata
  (function initLangToggle() {
    var btnIT = document.getElementById('ait-lang-it');
    var btnEN = document.getElementById('ait-lang-en');
    if (!btnIT || !btnEN) return;
    function setLang(lang) {
      aitLang = lang;
      localStorage.setItem('ait-lang', lang);
      t = aitT[lang] || aitT['it'];
      // Aggiorna stile bottoni
      btnIT.style.background = lang === 'it' ? '#1A7A4A' : 'transparent';
      btnIT.style.color = lang === 'it' ? '#fff' : '#888';
      btnEN.style.background = lang === 'en' ? '#1A7A4A' : 'transparent';
      btnEN.style.color = lang === 'en' ? '#fff' : '#888';
      // Riapplica traduzioni
      applyTranslations();
      // Aggiorna voce TTS
      ttsVoice = (lang === 'en' ? ttsVoiceEN : ttsVoiceIT) || ttsVoices[0] || null;
    }
    // Controlla se l'utente ha una preferenza salvata
    var saved = localStorage.getItem('ait-lang');
    if (saved === 'it' || saved === 'en') aitLang = saved;
    // Imposta stato iniziale bottoni
    btnIT.style.background = aitLang === 'it' ? '#1A7A4A' : 'transparent';
    btnIT.style.color = aitLang === 'it' ? '#fff' : '#888';
    btnEN.style.background = aitLang === 'en' ? '#1A7A4A' : 'transparent';
    btnEN.style.color = aitLang === 'en' ? '#fff' : '#888';
    t = aitT[aitLang] || aitT['it'];
    btnIT.addEventListener('click', function() { setLang('it'); });
    btnEN.addEventListener('click', function() { setLang('en'); });
  })();

  // Applica traduzioni UI — copre TUTTI i testi del widget
  function applyTranslations() {
    if (!t) return;
    var idMap = {
      'ait-tts-status': t.read, 'ait-tts-slow': t.slow, 'ait-tts-normal': t.normal, 'ait-tts-fast': t.fast,
      'ait-scan-rgaa-btn': t.scanBtn, 'ait-alt-text-btn': t.altBtn,
      'ait-alt-status': t.altReady, 'ait-alt-generate-btn': t.altGenerate, 'ait-alt-copy-btn': t.altCopy,
      'ait-reset-all': t.reset, 'ait-hide-widget': t.hide, 'ait-declaration': t.declaration
    };
    Object.keys(idMap).forEach(function(id) {
      var el = document.getElementById(id); if (el) el.textContent = idMap[id];
    });
    // Hint TTS
    var ttsHintEl = document.querySelector('#ait-panel .ait-section div[style*="font-size:11px"]');
    if (ttsHintEl) ttsHintEl.textContent = t.ttsHint;
    // Titoli sezioni con data-sec
    document.querySelectorAll('#ait-panel .ait-section-title[data-sec]').forEach(function(el) {
      var key = el.getAttribute('data-sec'); if (t[key]) el.textContent = t[key];
    });
    // Profili
    var profileMap = {
      'epilessia': t.profileEpilessia, 'ipovedenti': t.profileIpovedenti,
      'adhd': t.profileAdhd, 'lettura': t.profileLettura,
      'tastiera': t.profileTastiera, 'screenreader': t.profileScreenreader,
      'anziani': t.profileAnziani
    };
    Object.keys(profileMap).forEach(function(prof) {
      var sw = document.querySelector('.ait-toggle-switch[data-profile="' + prof + '"]');
      if (!sw) return;
      var hdr = sw.closest('.ait-profile-header');
      if (hdr) { var lbl = hdr.querySelector('.ait-profile-label'); if (lbl) lbl.textContent = profileMap[prof]; }
      var on = sw.querySelector('.ait-toggle-on'); var off = sw.querySelector('.ait-toggle-off');
      if (on) on.textContent = t.toggleOn; if (off) off.textContent = t.toggleOff;
    });
    // Info profili
    var infoMap = {
      'info-epilessia': t.infoEpilessia, 'info-ipovedenti': t.infoIpovedenti,
      'info-adhd': t.infoAdhd, 'info-lettura': t.infoLettura,
      'info-tastiera': t.infoTastiera, 'info-screenreader': t.infoScreenreader,
      'info-anziani': t.infoAnziani
    };
    Object.keys(infoMap).forEach(function(id) {
      var el = document.getElementById(id); if (el) el.textContent = infoMap[id];
    });
    // Bottoni toggle con data-toggle
    var toggleMap = {
      'font-readable': t.btnFontReadable, 'big-text': t.btnBigText,
      'highlight-links': t.btnHighlightLinks, 'big-cursor': t.btnBigCursor,
      'hide-images': t.btnHideImages, 'highlight-titles': t.btnHighlightTitles,
      'reading-mode': t.btnReadingMode,
      'high-contrast': t.btnHighContrast, 'grayscale': t.btnGrayscale,
      'dark-mode': t.btnDarkMode, 'contrast-light': t.btnContrastLight,
      'contrast-dark': t.btnContrastDark, 'contrast-high': t.btnContrastHigh,
      'saturation-high': t.btnSatHigh, 'saturation-low': t.btnSatLow,
      'monochrome': t.btnMono,
      'line-spacing': t.btnLineSpacing, 'letter-spacing': t.btnLetterSpacing,
      'stop-animations': t.btnStopAnim, 'reading-mask': t.btnReadingMask,
      'highlight-focus': t.btnHighlightFocus, 'highlight-hover': t.btnHighlightHover,
      'mute-sounds': t.btnMuteSounds
    };
    Object.keys(toggleMap).forEach(function(key) {
      var btn = document.querySelector('.ait-toggle-btn[data-toggle="' + key + '"]');
      if (btn) btn.textContent = toggleMap[key];
    });
    // Placeholder textarea alt text
    var ta = document.getElementById('ait-alt-text-output');
    if (ta) ta.placeholder = t.altPlaceholder;
  }
  applyTranslations(); // Chiamata iniziale


  // ---- TTS ----
  var ttsVoices = [];
  var ttsVoiceIT = null;
  var ttsVoiceEN = null;

  function loadVoices() {
    ttsVoices = window.speechSynthesis.getVoices();
    if (!ttsVoices.length) return;

    // Voce italiana femminile naturale: priorità Microsoft Elsa Online (Natural)
    var itPriority = ['elsa online','elsa','alice','federica','google italiano','elena','laura','chiara','sara'];
    ttsVoiceIT = null;
    for (var i = 0; i < itPriority.length; i++) {
      ttsVoiceIT = ttsVoices.find(function(v) {
        return v.lang.startsWith('it') && v.name.toLowerCase().includes(itPriority[i]);
      });
      if (ttsVoiceIT) break;
    }
    if (!ttsVoiceIT) ttsVoiceIT = ttsVoices.find(function(v) { return v.lang.startsWith('it'); }) || null;

    // Voce inglese femminile naturale: priorità Microsoft Aria Online (Natural)
    var enPriority = ['aria online','aria','zira','samantha','google us english','karen','moira'];
    ttsVoiceEN = null;
    for (var j = 0; j < enPriority.length; j++) {
      ttsVoiceEN = ttsVoices.find(function(v) {
        return v.lang.startsWith('en') && v.name.toLowerCase().includes(enPriority[j]);
      });
      if (ttsVoiceEN) break;
    }
    if (!ttsVoiceEN) ttsVoiceEN = ttsVoices.find(function(v) { return v.lang.startsWith('en'); }) || null;

    // Imposta la voce corrente in base alla lingua della pagina
    ttsVoice = (aitLang === 'en' ? ttsVoiceEN : ttsVoiceIT) || ttsVoices[0] || null;
  }

  if (window.speechSynthesis.onvoiceschanged !== undefined) window.speechSynthesis.onvoiceschanged = loadVoices;
  loadVoices();
  // Secondo tentativo dopo 500ms (Chrome carica le voci in modo asincrono)
  setTimeout(loadVoices, 500);

  function speak(text) {
    window.speechSynthesis.cancel();
    var u = new SpeechSynthesisUtterance(text);
    u.lang = aitLang === 'en' ? 'en-US' : 'it-IT';
    u.rate = ttsRate;
    u.pitch = 1.05;
    if (ttsVoice) u.voice = ttsVoice;
    u.onstart = function() { ttsActive = true; updateTTSBtn(); };
    u.onend = u.onerror = function() { ttsActive = false; updateTTSBtn(); };
    window.speechSynthesis.speak(u);
  }

  function updateTTSBtn() {
    var btn = document.getElementById('ait-tts-btn');
    var status = document.getElementById('ait-tts-status');
    if (btn) btn.style.background = ttsActive ? '#1A7A4A' : '#3b3b5e';
    if (status) status.textContent = ttsActive ? t.reading : t.read;
  }

  var ttsBtn = document.getElementById('ait-tts-btn');
  if (ttsBtn) {
    ttsBtn.addEventListener('click', function() {
      if (ttsActive) { window.speechSynthesis.cancel(); return; }
      var sel = window.getSelection().toString().trim();
      var text = sel || (document.body.innerText || '').replace(/\s+/g, ' ').trim().substring(0, 3000);
      speak(text);
    });
  }

  function setSpeed(rate, btn) {
    ttsRate = rate;
    ['ait-tts-slow','ait-tts-normal','ait-tts-fast'].forEach(function(id) {
      var b = document.getElementById(id);
      if (b) { b.style.borderColor = '#3b3b5e'; b.style.color = '#ccc'; }
    });
    if (btn) { btn.style.borderColor = '#1A7A4A'; btn.style.color = '#fff'; }
  }

  var slowBtn = document.getElementById('ait-tts-slow');
  var normBtn = document.getElementById('ait-tts-normal');
  var fastBtn = document.getElementById('ait-tts-fast');
  if (slowBtn) {
    slowBtn.addEventListener('click', function() { setSpeed(0.7, slowBtn); });
  }
  if (normBtn) {
    normBtn.addEventListener('click', function() { setSpeed(1.0, normBtn); });
  }
  if (fastBtn) {
    fastBtn.addEventListener('click', function() { setSpeed(1.4, fastBtn); });
  }

  // ---- FOCUS TRAP (WCAG 2.1) ----
  panel.addEventListener('keydown', function(e) {
    if (!panel.classList.contains('ait-open')) return;
    var focusable = panel.querySelectorAll('button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.key === 'Escape') {
      e.preventDefault();
      togglePanel(false);
      toggle.focus();
      return;
    }
    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  console.log('[ACCESSIBILE IT] Widget v3.2 caricato (con LegalBlink e maschera fix)');
})();
  } catch(e) { console.error(e); }
})();

})();
